import { useMemo } from 'react'

import { withDevFallbackTags } from 'Pods/SearchPage/devFallbackTags'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

// Backend (Items::SerializeCollection) emits tags as `[["slug", { thumbnailUrl, ... }], ...]`.
// Flatten to a simple `string[]` so downstream filters work with a single shape. Reads from the
// store (updated on every fetch), so contextual suggestions stay in sync with the current
// filter set.
export default function useSuggestedTags() {
  const resultTags = useSearchPageStore(state => state.resultTags)

  return useMemo(() => {
    const normalized = resultTags
      .map(entry => (Array.isArray(entry) ? entry[0] : entry))
      .filter(Boolean)
    return withDevFallbackTags(normalized)
  }, [resultTags])
}
